import { useParams } from 'react-router-dom';
import { useEffect, useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CONTENTFUL_ENTRIES } from '../constants/ContentConstats';
import { AppStore } from '../redux/store';

interface Property {
  name: string;
  url: string;
}

interface City {
  name: string;
  properties: Property[];
}

const useCities = () => {
  const { country: countryParam } = useParams<{ country: string }>();
  const { country } = useSelector((store: AppStore) => store.country);

  const [cities, setCities] = useState<City[]>([]);
  const [citiesBuy, setCitiesBuy] = useState<City[]>([]);
  const fetchInProgress = useRef(false);

  const fetchCities = useCallback(async () => {
    if (fetchInProgress.current) return;

    try {
      fetchInProgress.current = true;

      if (!country || !countryParam) {
        setCities([]);
        setCitiesBuy([]);
        return;
      }

      const countryKey = countryParam as keyof typeof CONTENTFUL_ENTRIES;
      const citiesEntryId = CONTENTFUL_ENTRIES[countryKey]?.cities;

      if (!citiesEntryId) {
        setCities([]);
        setCitiesBuy([]);
        return;
      }

      const response = await fetch(
        `https://cdn.contentful.com/spaces/2s65zqhp8au5/entries/${citiesEntryId}`,
        {
          headers: {
            Authorization: "Bearer y0IYxPnHITMQAbl3NERyBLUdvMzb8p3ON1tLtlDRna0",
          },
        }
      );

      const data = await response.json();

      const citiesData =
        typeof data.fields.cities === 'string'
          ? JSON.parse(data.fields.cities)
          : data.fields.cities;

      const citiesDataBuy =
        typeof data.fields.citiesBuy === 'string'
          ? JSON.parse(data.fields.citiesBuy)
          : data.fields.citiesBuy;

      if (Array.isArray(citiesData)) setCities(citiesData);
      if (Array.isArray(citiesDataBuy)) setCitiesBuy(citiesDataBuy);
    } catch (error) {
      console.error('Error fetching cities:', error);
    } finally {
      fetchInProgress.current = false;
    }
  }, [country, countryParam]);

  useEffect(() => {
    fetchCities();
  }, [fetchCities]);

  return {
    cities,
    citiesBuy,
    refetch: fetchCities,
  };
};

export default useCities;
